﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import queryString from "query-string";
import {loaderShow, loaderHide} from "./loader";

export function initShortListOperation() {
    initAddRemoveButtons();
    initClearButton();
}

function initAddRemoveButtons() {
    $("[data-shortlist-operation]").each(function () {
        if ($(this).data("shortlist-init")) {
            return;
        }
        $(this).on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            let url = $this.data("shortlist-operation");
            let isInShortlist = $this.data("is-in-shortlist");
            let quantity = $($this.data("quantity-selector")).val();
            let parsed = queryString.parse('');
            if (isInShortlist == true) {
                parsed.operation = "remove";
            } else {
                parsed.operation = "add";
                parsed.quantity = quantity;
            }
            url = queryString.stringifyUrl({url: url, query: parsed});
            sendShortlistOperation(url, function (data) {
                console.log({data})
                let holder = $(".shortlist.shortlist-header");
                holder.replaceWith(data);
                if (isInShortlist) {
                    $this.data("is-in-shortlist", false);
                    $this.text("Add to Shortlist");
                } else {
                    $this.data("is-in-shortlist", true);
                    $this.text("Remove from Shortlist");
                }
                initClearButton();
            });
        }).data("shortlist-init", true);
    });
}

function initClearButton() {
    $("[data-shortlist-clear]").each(function () {
        if ($(this).data("shortlist-init")) {
            return;
        }
        $(this).on("click", function (e) {
            e.preventDefault();
            const $this = $(this);
            let url = $this.data("shortlist-clear");
            sendShortlistOperation(url, function (data) {
                console.log({data})
                let holder = $(".shortlist.shortlist-header");
                holder.replaceWith(data);
                $("[data-shortlist-operation]").each(function () {
                    $(this).data("is-in-shortlist", false);
                    $(this).text("Add to Shortlist");
                });
                initClearButton();
            });
        }).data("shortlist-init", true);
    });
}

function sendShortlistOperation(source, callback = function () {
}, waiting = "body") {
    loaderShow(waiting);
    console.log(source);
    $.ajax({
        url: source, type: 'GET', dataType: 'html', success: function (data) {
            callback(data);
        }, error: function (error) {
            console.error(error);
        }, complete: function (event) {
            loaderHide(waiting);
        }
    });
}